import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import iconSprite from '../../../assets/icon-sprite.svg';

class CreateLoan extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    const {
      visible, history, onClose = function $() {}, onSubmit = function $() {},
    } = this.props;
    const { option } = this.state;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <form
          action=""
          className="modal-form"
          onSubmit={(e) => {
            e.preventDefault();
            if (this.state.option == 'single') history.push('/createsingleloan')
            else if (this.state.option == 'products') history.push('/createloanproduct')
            else onSubmit(this.state);
          }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Loan</h5>
              <button type="button" className="close" onClick={onClose}>
                <svg width="48" height="48">
                  <use xlinkHref={iconSprite + '#close-icon'}></use>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <p className="modal-body__p">
                How many loans would you like to add?
              </p>
              <div className="form-group">
                <label className="card-check card-check__radio">
                  <input
                    className="card-check__option"
                    type="radio"
                    name="option"
                    value="single"
                    onChange={this.handleOnChange} />
                  <div className="card-check__value">
                    <span className="card-check__checkmark"></span>
                    <p className="card-check__value-text">Single Loan</p>
                  </div>
                </label>
              </div>
              <div className="form-group">
                <label className="card-check card-check__radio">
                  <input
                    className="card-check__option"
                    type="radio"
                    name="option"
                    value="multiple"
                    onChange={this.handleOnChange} />
                  <div className="card-check__value">
                    <span className="card-check__checkmark"></span>
                    <p className="card-check__value-text">Bulk Loans</p>
                  </div>
                </label>
              </div>
              <div className="form-group">
                <label className="card-check card-check__radio">
                  <input
                    className="card-check__option"
                    type="radio"
                    name="option"
                    value="products"
                    onChange={this.handleOnChange} />
                  <div className="card-check__value">
                    <span className="card-check__checkmark"></span>
                    <p className="card-check__value-text">Products</p>
                  </div>
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!option}>
                Continue
              </button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default CreateLoan;
